import "../css/Reviews.css";

const reviews = [
  {
    text: "Élan feels like a pause from the world. Calm, thoughtful, and beautiful.",
    author: "Sophie L.",
  },
  {
    text: "I’ve never felt more listened to in a salon.",
    author: "Amara K.",
  },
  {
    text: "Luxury without pressure. Everything feels intentional.",
    author: "Daniel M.",
  },
  {
    text: "The space, the care, the results — unmatched.",
    author: "Isabelle R.",
  },
];

const Reviews = () => {
  return (
    <main className="salon-reviews">

      {/* HERO */}
      <section className="reviews-hero">
        <h1>Reviews</h1>
        <p>
          Words from clients<br />
          who return again.
        </p>
      </section>

      {/* QUOTES */}
      <section className="reviews-list">
        {reviews.map((review, index) => (
          <blockquote key={index}>
            <p>“{review.text}”</p>
            <span>{review.author}</span>
          </blockquote>
        ))}
      </section>

      {/* CLOSING */}
      <section className="reviews-closing">
        <p>
          Trust is the most<br />
          beautiful result.
        </p>
      </section>

    </main>
  );
};

export default Reviews;
